import { IError, IFetchRailOption, IFetchRailOptionByDirection, RailDirection } from '../rail/interfaces'
import { IExpinetFlight, IExpinetSelectedFlight } from './interfaces'

export const useState = (): FlightState => {
  return {
    aidaFlights: null,
    selectedFlight: null,
    railErrorMessage: '',
    railAdults: 0,
    railDirectionRNF: 'none',
    selectedRailOptionId: '',
    selectableRailOptions: {},
    selectedRailOption: null
  }
}

export interface FlightState {
  aidaFlights: IExpinetFlight | null
  selectedFlight: IExpinetSelectedFlight | null
  railErrorMessage: string
  railAdults: number
  railDirectionRNF: RailDirection
  selectedRailOptionId: string
  selectableRailOptions: IFetchRailOptionByDirection | IError
  selectedRailOption: IFetchRailOption | IError | null
}
